import { render, staticRenderFns } from "./SubRslEvAddUser.vue?vue&type=template&id=6531ffa6&scoped=true&"
import script from "./SubRslEvAddUser.vue?vue&type=script&lang=js&"
export * from "./SubRslEvAddUser.vue?vue&type=script&lang=js&"
import style0 from "./SubRslEvAddUser.vue?vue&type=style&index=0&id=6531ffa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531ffa6",
  null
  
)

export default component.exports